// chemistry-root-element.ts
import { isPrinting, windowSize } from "@adornis/base/client/frontend-helpers/index.js";
import { html } from "lit";
import { combineLatest, takeUntil } from "rxjs";
import { ChemistryLitElement } from "./chemistry-lit-element.js";
import { LoaderController } from "./controllers/loader-controller.js";
import "./elements/theming/design.js";
import { xComponents } from "./elements/x-components.js";
import { cordovaKeyboardShown, intrinsicHeight } from "./viewport.js";
var connected = false;
var chemistryRootElement = new Promise(
  (resolve) => rootElResolver = (value) => {
    if (connected)
      throw new Error("there should only be one ChemistryRootElement!");
    connected = true;
    resolve(value);
  }
);
var rootElResolver;
var ChemistryRootElement = class extends ChemistryLitElement {
  constructor() {
    super();
    this.loader = new LoaderController(this, {
      globalLoaderTemplate: xComponents(
        html` <x-flex w100 h100 center crossaxis-center> <x-loader></x-loader> </x-flex> `
      ),
      useGlobalLoader: true
    });
    this.loader.waitFor(document.fonts.ready);
  }
  connectedCallback() {
    super.connectedCallback();
    rootElResolver(this);
    const root = this.getRootNode();
    if (root !== window.document)
      throw new Error("ChemistryRootElement can only be used in window.document");
    combineLatest([intrinsicHeight, isPrinting]).pipe(takeUntil(this.disconnected)).subscribe(([height, printing]) => this._updateComponentHeight(height, printing));
    combineLatest([cordovaKeyboardShown, windowSize, isPrinting]).pipe(takeUntil(this.disconnected)).subscribe(([keyboardShown]) => {
      if (keyboardShown) {
        document.body.style.position = "fixed";
        document.body.style.top = "0";
        document.body.style.bottom = "0";
        document.body.style.width = "100%";
      } else {
        document.body.style.position = "unset";
        document.body.style.top = "unset";
        document.body.style.bottom = "unset";
        document.body.style.width = "100%";
      }
    });
  }
  _updateComponentHeight(height, printing) {
    this.style.display = "block";
    if (!printing) {
      this.style.height = `${height}px`;
      this.style.position = "fixed";
    } else {
      this.style.height = "unset";
      this.style.position = "unset";
    }
    document.body.style.height = `${height}px`;
    document.querySelector("html").style.overflow = "hidden";
    this.style.width = "100%";
  }
};
export {
  ChemistryRootElement,
  chemistryRootElement
};
